function Gallery(props){
    return(
        <>
            <h1 className="gal-1">Gallery</h1>
            <p className="par-1">Explore a collection of modern and creative visuals showcasing technology, teamwork, and innovative web development ideas.</p>
            <section className="gallery">
                {props.images.map((image, index) => (
                    <img 
                        key={index}
                        src={image}
                        alt={`gallery-${index}`}
                    />
                ))}
                <p className="par-2">Our gallery highlights the creativity and flexibility of modern web design using React components.
                    Each image represents innovation, collaboration, and the power of interactive user experiences.
                    Reactor is built to combine clean design with responsive and dynamic functionality.
                </p>
            </section>
        </>
    );
}

export default Gallery;